import { render } from "./Loader.vue?vue&type=template&id=4a00176b&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=4a00176b&scoped=true&lang=css"

import exportComponent from "D:\\WebstormProjects\\authpage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a00176b"]])

export default __exports__